
























































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwDiscreetProgress } from '@libs-uuif/shared/sw-progress';
const cssPrefix = 'defcon-progress';
@Component({
  components: {
    SwDiscreetProgress,
  },
})
export default class DefconProgress extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: Number, default: 0 })
  value: number;
  myStyle: any;

  getDefconValue() {
    return this.value;
  }
}
